// API Configuration
export const config = {
  apiKey: 'gthhcBudmdMywk4zUEtKG0CGHN5gmSWE', // Same as parent app
  environment: 'production', // or 'test'
  endpoints: {
    production: 'https://api.plex.com/v1/andon/alerts',
    test: 'https://api-test.plex.com/v1/andon/alerts'
  },
  // IP Access Control Configuration
  ipAccess: {
    enabled: true, // Set to false to disable IP checking
    // Add your actual Strand Products IP ranges here
    approvedRanges: [
      '192.168.1.0/24',   // Example: Strand Products internal network
      '10.0.0.0/8',       // Example: Corporate network
      '172.16.0.0/12',    // Example: Additional corporate range
    ],
    // Add specific IP addresses that should always be allowed
    approvedIPs: [
      '127.0.0.1',        // localhost
      '::1',              // localhost IPv6
      '71.80.179.9',      // Developer's local IP
      '76.80.170.90',     // Strand Products IP
      '47.143.29.217',    // Designer IP
      '47.149.182.54',     // Designer IP2
      '98.185.245.96',       // Designer Home IP
    ]
  }
};
